<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Payment Account Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Payment Account Settings</span>
        </h4>

        <div class="row no-margin mt-4">
            <div class="ibox col-md-12 px-4">
                <div class="ibox-title dashboard_title px-0">
                    <h4>Payment Account Settings</h4>
                </div>

                <div class="ibox-content px-0 pt-4 employee-table-wrapper">
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-overlay :show="showoverlay" rounded="sm">
                            <div class="clearfix company-other-settings">
                                <div class="col-md-12 px-3">

                                    <div class="col-sm-6 company-form-box-title mt-3 pl-0 mb-2">Select Banks</div>

                                    <b-form-group id="banks_slection-group">
                                        <table class="table dataTable no-sort-icon">
                                            <thead>
                                                <tr class="table-head">
                                                    <th><span>Name</span></th>
                                                    <th><span>Account No.</span></th>
                                                    <th><span>Account Name</span></th>
                                                    <th><span>Branch Name</span></th>
                                                    <th><span>Routing Number</span></th>
                                                    <th class="text-right"><span>Actions</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="hover-bg table-row border-bottom mx-2" v-for="bank in all_banks" :key="bank.value">
                                                    <td>
                                                        <div class="row no-gutters align-items-center">
                                                            <b-form-checkbox
                                                                :id="'bank_name_'+bank.value"
                                                                v-model="selected_banks[bank.value]"
                                                                :name="'bank_name_'+bank.value"
                                                                class="ml-3"
                                                                v-validate="{ required: false }"
                                                                value="1"
                                                                unchecked-value="0">
                                                            </b-form-checkbox>
                                                            <label class="col-md-6 pt-1 mb-0"><span class="mt-1 d-inline-block">{{bank.text}}</span></label>
                                                        </div>
                                                    </td>
                                                    <td>{{bank.account_no}}</td>
                                                    <td>{{bank.beneficiary_name}}</td>
                                                    <td>{{bank.branch_name}}</td>
                                                    <td>{{bank.routing_number}}</td>
                                                    <td class="text-right">
                                                        <div class="float-right position-relative">
                                                            <b-button-toolbar>
                                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;"
                                                                    href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    <b-icon icon="three-dots-vertical"></b-icon>
                                                                </a>
                                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                                    <b-button-group>
                                                                        <b-button variant="outline-secondary" @click="addEditBankDetails(bank.value)">
                                                                            <b-icon icon="pencil"></b-icon> Add/Edit
                                                                        </b-button>
                                                                    </b-button-group>
                                                                </div>
                                                            </b-button-toolbar>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-form-group>

                                </div>
                            </div>

                            <div class="col-md-12 px-3">
                                <div class="btn-wrapper text-center pt-5">
                                    <b-button type="submit" variant="primary">Save</b-button>
                                </div>
                            </div>

                        </b-overlay>
                    </b-form>
                </div>
            </div>
        </div>

        <b-modal id="payment_bank_modal" title="Add / Edit Bank Details" size="lg" hide-footer>
            <b-overlay :show="showoverlaymodal" rounded="sm">
                <b-form @submit.stop.prevent="onSubmitBankdetails">
                    <input type="hidden" v-model="fdata.id" name="id">

                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group id="bank_name-group" label="Bank Name" class="required-field" label-for="bank_name">
                                <b-form-input id="bank_name" name="bank_name" v-model="fdata.bank_name" v-validate="{ required: true}" :state="validateState('bank_name')" aria-describedby="bank_name-feedback" data-vv-as="Bank Name" disabled></b-form-input>
                                <b-form-invalid-feedback id="bank_name-feedback">{{ veeErrors.first('bank_name') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group id="account_no-group" label="Account No." class="required-field" label-for="account_no">
                                <b-form-input id="account_no" name="account_no" v-model="fdata.account_no" v-validate="{ required: true, min: 3, max: 18, numeric: true }" :state="validateState('account_no')" aria-describedby="account_no-feedback" data-vv-as="Account No."></b-form-input>
                                <b-form-invalid-feedback id="account_no-feedback">{{ veeErrors.first('account_no') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group id="beneficiary_name-group" label="Account Name" class="required-field" label-for="beneficiary_name">
                                <b-form-input id="beneficiary_name" name="beneficiary_name" v-model="fdata.beneficiary_name" v-validate="{ required: true, min: 3, regex: /^[a-zA-Z][a-zA-Z\s.]+$/ }" :state="validateState('beneficiary_name')" aria-describedby="beneficiary_name-feedback" data-vv-as="Account Name"></b-form-input>
                                <b-form-invalid-feedback id="beneficiary_name-feedback">{{ veeErrors.first('beneficiary_name') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group id="branch_name-group" label="Branch Name" class="" label-for="branch_name">
                                <b-form-input id="branch_name" name="branch_name" v-model="fdata.branch_name" v-validate="{ alpha_spaces: true, regex: /^[^\s].*$/ }" :state="validateState('branch_name')" aria-describedby="branch_name-feedback" data-vv-as="Branch Name"></b-form-input>
                                <b-form-invalid-feedback id="branch_name-feedback">{{ veeErrors.first('branch_name') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group id="routing_number-group" label="Routing No." class="" label-for="routing_number">
                                <b-form-input id="routing_number" name="routing_number" v-model="fdata.routing_number" v-validate="{ numeric: true }" :state="validateState('routing_number')" aria-describedby="routing_number-feedback" data-vv-as="Routing No."></b-form-input>
                                <b-form-invalid-feedback id="routing_number-feedback">{{ veeErrors.first('routing_number') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="btn-wrapper text-center pt-5">
                        <b-button type="submit" variant="primary">Submit</b-button>
                    </div>

                </b-form>
            </b-overlay>
        </b-modal>

    </div>
</template>

<script>
    export default{
        mounted() {
            //
        },
        props: [ 'flg'],
        components: {
        },
        data(){
            return {
                cu: window.location.href,
                ce: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : false,
                showoverlaymodal : false,
                go_back : false,
                go_next : false,
                finish : false,
                errormsg:[],

                banks : [
                    {text: 'ABBL', value:'ABBL'},
                    {text: 'BBL', value: 'BBL'},
                    {text: 'EBL', value: 'EBL'}
                ],
                checked_banks: [],
                selected_banks: [],
                all_banks: [],
                current_bank: '',
                fdata: {bank_name: this.current_bank, beneficiary_name: '', id: ''},
            }
        },
        methods:{

            showMessage: function()
            {
                let tmp_flg = 0;
                if(this.fdata.tax_zone != null)
                {
                    if(this.fdata.tax_zone.length > 0) tmp_flg = 1;
                }
                let childdata = {flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg, move_next:this.go_next , move_back:this.go_back , finish:this.finish};
                this.$emit('childToParent', childdata);
            },
            set_go_back(x){
                this.go_next = false;
                this.go_back = true;
                this.finish = false;
                if(x == 1) this.showMessage();
            },
            set_go_next(x){
                this.go_next = true;
                this.go_back = false;
                this.finish = false;
                if(x == 1) this.showMessage();
            },
            disable_set_go_next(){
                this.go_next = false;
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },

            getSelectedBanks: function()
            {
                this.showoverlay = true;
                axios.get(this.$api_url+'/get-payment-selcted-banks' , {
                    params: {
                    }
                }).then(function(response){
                    this.checked_banks = response.data;
                    for (var f_key in this.checked_banks) {
                        this.selected_banks[this.checked_banks[f_key]] = 1;
                    }
                    this.showoverlay = false;
                }.bind(this));
            },

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.successmsg = false;
                this.warningmsg = false;
                this.dangermsg = false;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    this.showoverlay = true;
                    e.preventDefault();
                    let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.selected_banks))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        if(parseInt(fval) > 0)
                            formData.append("selcted_banks[]", nm);
                    }

                    axios.post(this.$api_url+'/update-payment-selcted-banks', formData)
                            .then(function (response)
                            {
                                if(response.data.success){
                                    this.$bvToast.toast('Settings Saved!', {title: `Success`, variant: 'success', solid: true});
                                } else if(response.data.error){
                                    this.$bvToast.toast(response.data.message, {title: `Error`, variant: 'danger', solid: true});
                                }
                                currentObj.showoverlay = false;
                                currentObj.getSelectedBanks();
                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.showoverlay = false;
                                currentObj.errormsg = error.response.data.errors;
                                currentObj.$validator.reset();
                                for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    if(msg == 'The selcted banks field is required.'){
                                        msg = 'Need to select at least 1 (one) payment account.';
                                    }
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                }
                            });
                });
            },

            addEditBankDetails(bank_code)
            {
                let currentObj = this;
                const config = {}
                let formData = new FormData();
                formData.append('bank_code', bank_code);
                axios.post(this.$api_url+'/getpaymentbankinfo', formData, config)
                            .then(function (response)
                            {
                                if(response.data.length > 0){
                                    response.data.forEach(function (bank) {
                                        if(bank.id){
                                            currentObj.fdata.id = bank.id;
                                        }
                                        currentObj.fdata.account_no = bank.account_no;
                                        currentObj.fdata.beneficiary_name = bank.beneficiary_name;
                                        currentObj.fdata.branch_name = bank.branch_name;
                                        currentObj.fdata.routing_number = bank.routing_number;
                                    });
                                } else {
                                    currentObj.fdata.id = '';
                                    currentObj.fdata.account_no = '';
                                    currentObj.fdata.beneficiary_name = '';
                                    currentObj.fdata.branch_name = '';
                                    currentObj.fdata.routing_number = '';
                                }
                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });
                this.current_bank = bank_code;
                this.fdata.bank_name = bank_code;
                this.$bvModal.show('payment_bank_modal');
            },

            onSubmitBankdetails(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlaymodal = true;
                    let currentObj = this;
                    e.preventDefault();

                    const config = {}
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }
                    axios.post(this.$api_url+'/savepaymentbankinfo', formData, config)
                            .then(function (response)
                            {
                                this.$bvModal.hide('payment_bank_modal');
                                this.successmsg = 'Saved!';
                                this.$bvToast.toast(this.successmsg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.$validator.reset();
                                this.showoverlaymodal = false;
                                this.getAllBanksInfo();
                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.showoverlaymodal = false;
                                currentObj.serverError(error);
                            });
                });
            },

            getAllBanksInfo()
            {
                let currentObj = this;
                const config = {}
                let formData = new FormData();
                axios.post(this.$api_url+'/getpaymentbankinfo', formData, config)
                        .then(function (response)
                        {
                            currentObj.all_banks = response.data;
                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                        });
            },

        },
        created: function(){
            this.getAcl();
            this.getSelectedBanks();
            this.getAllBanksInfo();
            this.$validator.reset();
        }
    }
</script>
